<!-- Este compoente vai ser removido junto com o datafilter -->
<template>
  <v-text-field v-model="local" v-bind="$attrs" />
</template>

<!-- Este compoente vai ser removido junto com o datafilter -->
<script>
import Cleave from 'cleave.js';

export default {
  props: {
    value: {
      type: null,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalMark: ',',
        delimiter: '.',
        numeralPositiveOnly: true,
        numeralPositivePattern: '0,00 $',
      }),
    },
  },
  data() {
    return {
      local: this.value,
      cleave: null,
    };
  },
  mounted() {
    this.initializeCleave();
  },
  beforeDestroy() {
    this.destroyCleave();
  },
  methods: {
    initializeCleave() {
      this.cleave = new Cleave(this.$el.querySelector('input'), {
        ...this.options,
        onValueChanged: this.onValueChanged.bind(this),
      });

      this.cleave.setRawValue(this.value);
    },
    destroyCleave() {
      if (this.cleave) {
        this.cleave.destroy();
        this.cleave = null;
      }
    },
    onValueChanged({ target }) {
      this.$nextTick(() => {
        this.local = target.value;
        this.$emit('input', target?.rawValue);
        this.$emit('input-formatted-value', target?.value);
      });
    },
  },
};
</script>
